"use client";

import { useEffect, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { getUTMParams, storeUTMParams } from '@/lib/utm';

function UTMTrackerContent() {
    const searchParams = useSearchParams();

    useEffect(() => {
        if (searchParams) {
            const currentParams = getUTMParams(searchParams);
            if (Object.keys(currentParams).length > 0) {
                storeUTMParams(currentParams);
            }
        }
    }, [searchParams]);

    return null;
}

/**
 * Global component to capture and persist UTM parameters.
 * Must be wrapped in Suspense because it uses useSearchParams().
 */
export function UTMTracker() {
    return (
        <Suspense fallback={null}>
            <UTMTrackerContent />
        </Suspense>
    );
}
